export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'contact_manage',
  'report_manage',
  'knowledge_base_manage',
  'kanban_access',
  'erp_external_catalog_access',
  'erp_sisplan_access',
  'erp_sisplan_pedidos_access',
  'erp_sisplan_amostras_access',
  'erp_sisplan_reports_access',
  'erp_sisplan_plano_costura_access',
  'erp_sisplan_production_access',
  'erp_sisplan_homologation_access',
  'erp_turismo_access',
  'erp_gdl_access',
];

export const ROLES = ['agent', 'administrator'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

export const KANBAN_PERMISSIONS = 'kanban_access';

export const KANBAN_ROUTE_PERMISSIONS = [...ROLES, KANBAN_PERMISSIONS];

export const ERP_EXTERNAL_CATALOG_PERMISSIONS = 'erp_external_catalog_access';

export const ERP_SISPLAN_PERMISSIONS = 'erp_sisplan_access';

export const ERP_SISPLAN_PEDIDOS_PERMISSIONS = 'erp_sisplan_pedidos_access';

export const ERP_SISPLAN_AMOSTRAS_PERMISSIONS = 'erp_sisplan_amostras_access';

export const ERP_SISPLAN_REPORTS_PERMISSIONS = 'erp_sisplan_reports_access';

export const ERP_SISPLAN_PLANO_COSTURA_PERMISSIONS =
  'erp_sisplan_plano_costura_access';

export const ERP_SISPLAN_PRODUCTION_PERMISSIONS =
  'erp_sisplan_production_access';

export const ERP_SISPLAN_HOMOLOGATION_PERMISSIONS =
  'erp_sisplan_homologation_access';

export const ERP_TURISMO_PERMISSIONS = 'erp_turismo_access';

export const ERP_GDL_PERMISSIONS = 'erp_gdl_access';

export const ERP_ROUTE_PERMISSIONS = [
  ...ROLES,
  ERP_EXTERNAL_CATALOG_PERMISSIONS,
  ERP_SISPLAN_PERMISSIONS,
  ERP_SISPLAN_PEDIDOS_PERMISSIONS,
  ERP_SISPLAN_AMOSTRAS_PERMISSIONS,
  ERP_SISPLAN_REPORTS_PERMISSIONS,
  ERP_SISPLAN_PLANO_COSTURA_PERMISSIONS,
  ERP_SISPLAN_PRODUCTION_PERMISSIONS,
  ERP_SISPLAN_HOMOLOGATION_PERMISSIONS,
  ERP_TURISMO_PERMISSIONS,
  ERP_GDL_PERMISSIONS,
];

export const ERP_EXTERNAL_CATALOG_ROUTE_PERMISSIONS = [
  ...ROLES,
  ERP_EXTERNAL_CATALOG_PERMISSIONS,
];

export const ERP_SISPLAN_ROUTE_PERMISSIONS = [
  ...ROLES,
  ERP_SISPLAN_PERMISSIONS,
  ERP_SISPLAN_PEDIDOS_PERMISSIONS,
  ERP_SISPLAN_AMOSTRAS_PERMISSIONS,
  ERP_SISPLAN_REPORTS_PERMISSIONS,
  ERP_SISPLAN_PLANO_COSTURA_PERMISSIONS,
  ERP_SISPLAN_PRODUCTION_PERMISSIONS,
  ERP_SISPLAN_HOMOLOGATION_PERMISSIONS,
];

export const ERP_SISPLAN_PEDIDOS_ROUTE_PERMISSIONS = [
  ...ROLES,
  ERP_SISPLAN_PERMISSIONS,
  ERP_SISPLAN_PEDIDOS_PERMISSIONS,
  ERP_SISPLAN_PRODUCTION_PERMISSIONS,
  ERP_SISPLAN_HOMOLOGATION_PERMISSIONS,
];

export const ERP_SISPLAN_AMOSTRAS_ROUTE_PERMISSIONS = [
  ...ROLES,
  ERP_SISPLAN_PERMISSIONS,
  ERP_SISPLAN_AMOSTRAS_PERMISSIONS,
];

export const ERP_SISPLAN_REPORTS_ROUTE_PERMISSIONS = [
  'administrator',
  ERP_SISPLAN_PERMISSIONS,
  ERP_SISPLAN_REPORTS_PERMISSIONS,
];

export const ERP_SISPLAN_PLANO_COSTURA_ROUTE_PERMISSIONS = [
  'administrator',
  ERP_SISPLAN_PERMISSIONS,
  ERP_SISPLAN_PLANO_COSTURA_PERMISSIONS,
];

export const ERP_TURISMO_ROUTE_PERMISSIONS = [
  ...ROLES,
  ERP_TURISMO_PERMISSIONS,
];

export const ERP_GDL_ROUTE_PERMISSIONS = [
  ...ROLES,
  ERP_GDL_PERMISSIONS,
  REPORTS_PERMISSIONS,
];

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  all: {
    count: 'allCount',
    permissions: [...ROLES, MANAGE_ALL_CONVERSATION_PERMISSIONS],
  },
};
